import React, { ReactNode } from 'react'
import { StyledIcon } from './styles'

interface InputIconProps {
  children: ReactNode
  padding?: string
  onClick?: () => void
}

export const InputIcon = ({ children, padding, onClick }: InputIconProps) => {
  return (
    <StyledIcon padding={padding} onClick={onClick}>
      {children}
    </StyledIcon>
  )
}
